import App from "./App.vue";
import router from "./router";
import { createApp } from "vue";
import axios from "./axios";
import "./assets/css/app.scss";
import i18n from "./translations/i18n";
import "bootstrap/dist/css/bootstrap.min.css";
const app = createApp(App);
app.use(i18n);
app.use(router);
app.config.globalProperties.$axios = axios;
app.mount("#app");
